import { IStep } from "@/interfaces/IStep";

export const steps: IStep[] = [
  {
    title: "Wybierz typ siodła",
    disabled: false,
  },
  {
    title: "Dostosuj siodło",
    disabled: false,
  },
  {
    title: "Prześlij wybrany wariant",
    disabled: false,
  },
];
